import React, { Component } from 'react';
import ABSLink from '../../../../../../components/ABSLink';
import authService from '../../../../../services/auth/authService';
import './menuLinkCard.less';

export interface IABSMenuLinkCardProps {
  menuDetail: any;
  showHot?: boolean;
  menuColorIndex?: number;
  onShowMenuModal?: () => void;
  onShowMenuLogin?: () => void;
  setClickUrl?: (clickUrl: string) => void;
  login: boolean;
}

class ABSMenuLinkCard extends Component<IABSMenuLinkCardProps> {
  renderHot = () => {
    const { showHot } = this.props;
    if (!showHot) { return null; }
    return (
      <div className="abs-home-menu-item-hot">hot</div>
    );
  };

  goFunctionUrl = () => {
    const { menuDetail, onShowMenuModal, login, onShowMenuLogin, setClickUrl } = this.props;
    let url = menuDetail.url ? menuDetail.url : '';
    if (menuDetail) {
      if (login) {
        if (authService.hasPermission(menuDetail.key)) {
          location.href = url;
        } else {
          if (onShowMenuModal) {
            onShowMenuModal();
          }
        }
      } else { // 未登录
          if (setClickUrl) {
            if (!menuDetail.isOpen) { url = ''; }
            setClickUrl(url);
          }
          if (!menuDetail.isAnoymous) {
            if (onShowMenuLogin) {
              onShowMenuLogin();
            }
          } else {
            location.href = url;
          }
      }
    }
  }

  render() {
    const { menuDetail, menuColorIndex } = this.props;
    if (!menuDetail) {
      return (
        <div className={`abs-home-menu-item abs-home-menu-item-bg${menuColorIndex}`}>
           {}
        </div>
      );
    }
    return (
      <div className={`abs-home-menu-item abs-home-menu-item-bg${menuColorIndex}`} onClick={this.goFunctionUrl}>
        <ABSLink to={menuDetail.url} onClick={() => { return; }}>
          {menuDetail.name}
        </ABSLink>
        {this.renderHot()}
      </div>
    );
  }
}

export default ABSMenuLinkCard; 


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/abs/views/home/component/left/components/menuLinkCard.tsx